<h1 i18n="@@WelcomeHeader">Willkommen</h1>

<p *ifRoles='["Administrator"]' i18n="@@RoleIsAdmin">Rolle ist Admin</p>

<div *ifRoles='["User"]' i18n="@@RoleIsUser">
  Rolle ist Benutzer
</div>

<p *ifRoles='["Customer"]' i18n="@@RoleIsCustomer">Rolle ist Kunde</p>
